/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
// import image from "../images/design-desk.jpeg";
import image from "../images/laptop_also.jpg";

const imageAltText = "a laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "GPT-2.X🌸🤖",
    description:
      "Re-implemented a transformer based decoder-only clone of OpenAI’s GPT-2 model using PyTorch from scratch!",
    url: "https://github.com/sdrshn-nmbr/gpt-2.x",
  },
  {
    title: "STM Snake🐍",
    description:
      "A snake game that can run on an LCD display, one STM 32, and a good ol' fashioned keyapad - all on a breadboard!",
    url: "https://github.com/sdrshn-nmbr/gpt-2.x",
  },
  {
    title: "Outlify👖👟",
    description:
      "Developed an open-source AI powered application for personalized outfit suggestions by scanning user's wardrobe utilizing Multimodal LLMs, Flask and Supabase!",
    url: "https://github.com/sdrshn-nmbr/Outlify",
  },
  {
    title: "Djitter🐥",
    description:
      "A Twitter clone built with Django that allows users to create chirps and interact with other users in real time in a secure environment using robust authentication.",
    url: "https://github.com/sdrshn-nmbr/Djitter-The-Twitter-Clone",
  },
  {
    title: "{JSONify}👩🏽‍💻",
    description:
      "A JSON parser and serializer in C to generate and validate JSON data from multiple source file formats with 100% accuracy",
    url: "https://github.com/sdrshn-nmbr/JSONify",
  },
  {
    title: "My Resume📄",
    description: "...showcasing my skills, projects, and experience.",
    url: "https://docs.google.com/document/d/1WXBhnJj_WyRY1mjt3JUy4_OTktBfaX5aM8Rc5XozABQ/edit?usp=sharing",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{
              height: "90%",
              width: "100%",
              objectFit: "cover",
              animation: "1s ease-out 0s 1 slideIn",
            }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
